
$(function() {
    const fbSendEvents = window.FBPixelDefined;

    // Payment confirmation page AddToCart and InitiateCheckout, and payment success page Purchase pixel events. eventID
    // matches the Conversions API events sent by PaymentController::doFbCheckoutEvents() / success() so FB can dedupe them
    if (fbSendEvents && typeof fbCheckoutEvents === 'object' && fbCheckoutEvents && fbCheckoutEvents.length) {
        fbCheckoutEvents.forEach(event => {
            fbq('track', event.event_name, event.custom_data, { eventID: event.event_id });
        });
    }

    // promotional Webinar Page pixel tracking
    // Facebook's CompleteRegistration event for this is now sent
    // server-side via the Conversions API (see
    // PromotionalWebinarAttendee::fireSignedUpFbEvent()).
    var $webinarPromotionalUserSignedUp = $('#js_ga_attendeeSignedUp');
    if ($webinarPromotionalUserSignedUp.length) {
        let fbReferralSignupData = {
            content_name: 'Promotional Webinar Attendee Signed Up'
        };

        // if (fbSendEvents) {
        //     fbq('track', 'CompleteRegistration', fbReferralSignupData);
        // }

        if (window.RedditPixelDefined) {
            rdt('track', 'SignUp');
        }

        if (window.TiktokPixelDefined) {
            window.ttq.track('CompleteRegistration', fbReferralSignupData);
        }
    }

    // Referral page Facebook pixel tracking
    var referralSignup = $('#js_fb_referralSignup');
    if (referralSignup.length) {
        let canSend = (referralSignup.data('urlsegment') != '' ? true : false);
        let fbReferralSignupData = {
            content_name: 'Free Tuning Series Signed Up',
            content_category: referralSignup.data('urlsegment')
        };

        if (fbSendEvents) {
            if (canSend) {
                // eventID matches the Conversions API event sent by ReferralPageController::doReferralForm() so FB can dedupe them
                const fbEventIDSignUp = referralSignup.data('fb-event-id');
                fbq('track', 'CompleteRegistration', fbReferralSignupData, (fbEventIDSignUp ? { eventID: fbEventIDSignUp } : {}));
            }
        }

        if (window.RedditPixelDefined) {
            if (canSend) {
                rdt('track', 'SignUp');
            }
        }

        if (window.TiktokPixelDefined) {
            if (canSend) {
                window.ttq.track('CompleteRegistration', fbReferralSignupData);
            }
        }
    }
});



// WEBPACK FOOTER //
// ./js/modules/fb.js